import { reducer as AppReducer } from './AppRedux';
import { reducer as LoginReducer } from './LoginRedux';
import { reducer as LogTypesReducer } from './LogTypesRedux';
import { reducer as LogReducer } from './LogRedux';

export default { AppReducer, LoginReducer, LogTypesReducer, LogReducer };
